export const formikSelectFieldRoundedControlStyle = {
  borderColor: '#D6D6D6',
  borderRadius: 4,
  padding: 5,
};

export const formikSelectFieldRoundedMenuStyle = {
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
};
